function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import T from 'prop-types';
import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useAsyncFn, useList } from 'react-use';
import text from '../../../text';
import { client } from '../../../utilities/api';
import InviteUserForm from '../../form/inviteUserForm/InviteUserForm';
import InvitationTable from '../../table/invitationTable/InvitationTable';
export var INVITE_PROJECT_USERS_MODAL = 'INVITE_PROJECT_USERS_MODAL';
var InviteProjectUsersModal = function(props) {
    var show = props.show, project = props.project, onHide = props.onHide, restProps = _object_without_properties(props, [
        "show",
        "project",
        "onHide"
    ]);
    var _useList = _sliced_to_array(useList(), 2), projectInvitation = _useList[0], _useList_ = _useList[1], set = _useList_.set, insertAt = _useList_.insertAt, removeAt = _useList_.removeAt, clear = _useList_.clear, updateAt = _useList_.updateAt;
    var isValidInvitee = function(inviteeEmail) {
        return !projectInvitation.some(function(param) {
            var user = param.user;
            return user.email === inviteeEmail;
        });
    };
    var _useAsyncFn = _sliced_to_array(useAsyncFn(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(project, email) {
            var isResend, data;
            var _arguments = arguments;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isResend = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        return [
                            4,
                            client.inviteUserToProject(project.id, email)
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (!isResend) {
                            insertAt(0, _object_spread({}, data));
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function(project, email) {
            return _ref.apply(this, arguments);
        };
    }()), 2), inviteState = _useAsyncFn[0], inviteUser = _useAsyncFn[1];
    var invitationIndex = function(userId) {
        return projectInvitation.findIndex(function(invitation) {
            return invitation.user.id === userId;
        });
    };
    var removeProjectUser = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectToRemove, invite) {
            var _invite_user, index;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        index = invitationIndex(invite.user.id);
                        return [
                            4,
                            client.removeUserFromProject(projectToRemove === null || projectToRemove === void 0 ? void 0 : projectToRemove.id, invite === null || invite === void 0 ? void 0 : (_invite_user = invite.user) === null || _invite_user === void 0 ? void 0 : _invite_user.email)
                        ];
                    case 1:
                        _state.sent();
                        removeAt(index);
                        return [
                            2
                        ];
                }
            });
        });
        return function removeProjectUser(projectToRemove, invite) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateUserProjectVisibility = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(invite) {
            var visibility, index, updatedInvite;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        visibility = invite.visibility === 'public' ? 'staff' : 'public';
                        index = invitationIndex(invite.user.id);
                        return [
                            4,
                            client.updateUserProjectVisibility(project.id, invite.user.id, visibility)
                        ];
                    case 1:
                        _state.sent();
                        updatedInvite = _object_spread_props(_object_spread({}, invite), {
                            visibility: visibility
                        });
                        updateAt(index, updatedInvite);
                        return [
                            2
                        ];
                }
            });
        });
        return function updateUserProjectVisibility(invite) {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(/*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(project && show)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        client.listProjectUsers(project.id)
                    ];
                case 1:
                    data = _state.sent().data;
                    set(data);
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    }), [
        show
    ]);
    var onHandleHide = function() {
        clear();
        onHide();
    };
    return /*#__PURE__*/ React.createElement(Modal, _object_spread({
        centered: true,
        scrollable: true,
        show: show,
        onHide: onHandleHide
    }, restProps), /*#__PURE__*/ React.createElement(Modal.Header, {
        className: "align-end",
        closeButton: true
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("h3", {
        className: "secondary"
    }, text('inviteProjectUser')), (project === null || project === void 0 ? void 0 : project.name) && /*#__PURE__*/ React.createElement("h6", {
        className: "mt-2"
    }, project.name))), /*#__PURE__*/ React.createElement(InviteUserForm, {
        isLoading: inviteState.loading,
        isValidUser: isValidInvitee,
        onSubmit: function(email) {
            return inviteUser(project, email);
        }
    }), /*#__PURE__*/ React.createElement(InvitationTable, {
        callback: set,
        resendInvitation: function(email) {
            return inviteUser(project, email, true);
        },
        removeProjectUser: removeProjectUser,
        updateUserProjectVisibility: updateUserProjectVisibility,
        project: project,
        // job={job}
        invitations: projectInvitation
    }));
};
InviteProjectUsersModal.propTypes = {
    project: T.shape(),
    job: T.object,
    onHide: T.func,
    show: T.bool
};
export default InviteProjectUsersModal;
